import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, switchMap, interval } from 'rxjs';
import { environment as env } from 'src/environments/environment';
import { LocalStorageService } from './local-storage.service';
import { SuccessResponse } from '../models';
import { getCountryCode} from '../util/util';

export enum Api {
  ACCESS_CONTROL = 'ACCESS_CONTROL_API_BASE_URL',
  ARTICO = 'ARTICO_API_BASE_URL',
  EXTERNAL_SOURCES = 'EXTERNAL_SOURCE_API_BASE_URL',
  AMARU = 'AMARU_API_BASE_URL',
  REPO_DOCUMENTAL = 'REPO_DOCUMENTAL_API_BASE_URL',
}

@Injectable({
  providedIn: 'root',
})
export class ApigatewayService {
  constructor(private httpClient: HttpClient, private localStorageService: LocalStorageService) {
    const time = 60000;
    interval(time)
      .pipe(switchMap(() => this.selectAccApiGateway()))
      .subscribe();
  }

  async selectAccApiGateway() {
    const { ACC_API_GATEWAYS } = env;

    const pingServce = `${env.ARTICO_API_BASE_URL}${env.PING_SERVICE}?codEmpresa=${
      getCountryCode() ?? 'PE'
    }`;
    const urlTimes = [];

    for (let i = 0; i < ACC_API_GATEWAYS.length; i += 1) {
      const URL = `${ACC_API_GATEWAYS[i]}${pingServce}`;
      try {
        const startTime = new Date().getTime();
        const response = await lastValueFrom(
          this.httpClient.get<SuccessResponse>(URL, { observe: 'response' })
        );
        const endTime = new Date().getTime();
        const duration = endTime - startTime;

        if (response.body) {
          urlTimes.push(`${duration}-${i}`);
        } else {
          urlTimes.push(`${100000000000}-${i}`);
        }
      } catch (error) {
        urlTimes.push(`${100000000000}-${i}`);
      }
    }

    urlTimes.sort((a, b) => a - b);
    const bestUrlTime = urlTimes[0]?.split('-')[1];
    this.localStorageService.set('BEST_ACC_URL', ACC_API_GATEWAYS[bestUrlTime]);
  }

  getBestApiGateway(isPublic?: boolean) {
    const publicGateways = {
      PE: env.DEFAULT_API_GATEWAY_PUBLIC,
      MX: env.DEFAULT_API_GATEWAY_PUBLIC_MX,
    };
    if (isPublic) {
      const countryCode = getCountryCode(); 
      return publicGateways[countryCode] || env.DEFAULT_API_GATEWAY_PUBLIC;
    }
    const bestApi = this.localStorageService.get('BEST_ACC_URL');
    return bestApi || env.DEFAULT_API_GATEWAY;
  }

  getApiUrl(api: Api, isPublic?: boolean): String {
    const url = env[`${api}_FORCED`]
      ? env[`${api}_FORCED`]
      : `${this.getBestApiGateway(isPublic)}${env[`${api}`]}`;
    return url;
  }
}
